export const getIndicatorLetter = (index: number) => String.fromCharCode("A".charCodeAt(0) + index);
